import type { GameRuleWorkspaceRow } from "../types/gameRuleWorkspace";

export type PrizeLogicListingPrimaryAction = "Resume" | "Review" | "Open";

/** Case-insensitive email equality for reviewer assignment checks. */
export function emailsMatchIgnoreCase(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  const left = a?.trim().toLowerCase() ?? "";
  const right = b?.trim().toLowerCase() ?? "";
  return left.length > 0 && left === right;
}

/**
 * Primary listing CTA: sessions → Resume; assigned pending-review docs → Review; else Open.
 */
export function getPrizeLogicListingPrimaryAction(
  row: Pick<GameRuleWorkspaceRow, "kind" | "statusKey" | "reviewerEmail">,
  currentUserEmail: string | null | undefined,
): PrizeLogicListingPrimaryAction {
  if (row.kind === "session") {
    return "Resume";
  }
  if (
    row.statusKey === "review" &&
    emailsMatchIgnoreCase(row.reviewerEmail, currentUserEmail)
  ) {
    return "Review";
  }
  return "Open";
}
